import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("gg_token");
    if (!token) { setLoading(false); return; }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (e) {
      localStorage.removeItem("gg_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (token) => {
    localStorage.setItem("gg_token", token);
    setLoading(true);
    await fetchMe();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("gg_token");
    setUser(null);
  };

  const hasPerm = (p) => user?.permissions?.includes(p);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, hasPerm, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};
